import type { FormEvent } from 'react'

import { recordAttributionLeadCaptured, trackCrmUser } from '../crm-service'
import type { BrazeCustomEventName, BrazeRegisterUserAdditionalFields } from './brazeConstants'

export const registerBrazeUserWithEmail = async (
  email: string,
  customEventName: BrazeCustomEventName,
  marketingConsent: boolean,
  additionalFields?: Record<string, unknown>,
  customEventProperties?: Record<string, unknown>,
) => {
  try {
    await trackCrmUser(email, customEventName, marketingConsent, additionalFields, customEventProperties)
    void recordAttributionLeadCaptured()
  } catch (error) {
    if (error instanceof Error) {
      throw new Error(`Failed to register Braze user with email: ${error.message}`)
    } else {
      throw new Error('Failed to register Braze user with email: unknown error')
    }
  }
}

export const registerBrazeUserWithEmailFromWebForm = async (
  event: FormEvent<HTMLFormElement>,
  email: string,
  customEventName: BrazeCustomEventName,
  callback: (success: boolean, message?: string) => void,
  marketingConsent: boolean,
  additionalFields?: BrazeRegisterUserAdditionalFields,
  customEventProperties?: Record<string, unknown>,
) => {
  event.preventDefault()

  try {
    await trackCrmUser(email, customEventName, marketingConsent, additionalFields, customEventProperties)
    void recordAttributionLeadCaptured()
    callback(true)
  } catch {
    callback(false, 'Something went wrong - please try again.')
  }
}
